import React from "react";
import Logo40AnosPositivoImg from "@monorepo-amais/commons/assets/img/diagnoson-40-anos-positivo.svg";

const Logo40AnosPositivo = (props) => (
  <img src={Logo40AnosPositivoImg} alt="Logo 40 Anos Positivo" style={{
    width: props.width || "95%",
    height: props.height || "95%",
    }}
   />
);

export default Logo40AnosPositivo;
